/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ APP_NAME: NonNullable<unknown> }} Plans_Page_TitleInputs */

const en_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plans | ${i?.APP_NAME}`)
};

const id_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paket | ${i?.APP_NAME}`)
};

const ms_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pelan | ${i?.APP_NAME}`)
};

const ca_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plans | ${i?.APP_NAME}`)
};

const cs_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plány | ${i?.APP_NAME}`)
};

const da_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnementer | ${i?.APP_NAME}`)
};

const de_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnements | ${i?.APP_NAME}`)
};

const et_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plaanid | ${i?.APP_NAME}`)
};

const es_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscripciones | ${i?.APP_NAME}`)
};

const fr_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnements | ${i?.APP_NAME}`)
};

const hr_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pretplate | ${i?.APP_NAME}`)
};

const it_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piani | ${i?.APP_NAME}`)
};

const lv_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plāni | ${i?.APP_NAME}`)
};

const lt_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planai | ${i?.APP_NAME}`)
};

const hu_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Előfizetések | ${i?.APP_NAME}`)
};

const nl_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnementen | ${i?.APP_NAME}`)
};

const nb_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnementer | ${i?.APP_NAME}`)
};

const pl_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usługi | ${i?.APP_NAME}`)
};

const pt_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planos | ${i?.APP_NAME}`)
};

const ro_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planuri | ${i?.APP_NAME}`)
};

const sk_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plány | ${i?.APP_NAME}`)
};

const sl_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Načrti | ${i?.APP_NAME}`)
};

const fi_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilaukset | ${i?.APP_NAME}`)
};

const sv_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planer | ${i?.APP_NAME}`)
};

const vi_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gói | ${i?.APP_NAME}`)
};

const tr_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planlar | ${i?.APP_NAME}`)
};

const el_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Προγράμματα| ${i?.APP_NAME}`)
};

const bg_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Планове | ${i?.APP_NAME}`)
};

const ru_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Планы | ${i?.APP_NAME}`)
};

const sr_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пакети | ${i?.APP_NAME}`)
};

const uk_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Плани | ${i?.APP_NAME}`)
};

const ka_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`გამოწერები | ${i?.APP_NAME}`)
};

const hi_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्लान्स | ${i?.APP_NAME}`)
};

const th_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แพ็กเกจ | ${i?.APP_NAME}`)
};

const ko_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`플랜 | ${i?.APP_NAME}`)
};

const zh_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`套餐 | ${i?.APP_NAME}`)
};

const zh_tw_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`方案 | ${i?.APP_NAME}`)
};

const ja_plans_page_title = /** @type {(inputs: Plans_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プラン｜ ${i?.APP_NAME}`)
};

/**
* | output |
* | --- |
* | "Plans \| {APP_NAME}" |
*
* @param {Plans_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const plans_page_title = /** @type {((inputs: Plans_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plans_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plans_page_title(inputs)
	if (locale === "ms") return ms_plans_page_title(inputs)
	if (locale === "ca") return ca_plans_page_title(inputs)
	if (locale === "cs") return cs_plans_page_title(inputs)
	if (locale === "da") return da_plans_page_title(inputs)
	if (locale === "de") return de_plans_page_title(inputs)
	if (locale === "et") return et_plans_page_title(inputs)
	if (locale === "es") return es_plans_page_title(inputs)
	if (locale === "fr") return fr_plans_page_title(inputs)
	if (locale === "hr") return hr_plans_page_title(inputs)
	if (locale === "it") return it_plans_page_title(inputs)
	if (locale === "lv") return lv_plans_page_title(inputs)
	if (locale === "lt") return lt_plans_page_title(inputs)
	if (locale === "hu") return hu_plans_page_title(inputs)
	if (locale === "nl") return nl_plans_page_title(inputs)
	if (locale === "nb") return nb_plans_page_title(inputs)
	if (locale === "pl") return pl_plans_page_title(inputs)
	if (locale === "pt") return pt_plans_page_title(inputs)
	if (locale === "ro") return ro_plans_page_title(inputs)
	if (locale === "sk") return sk_plans_page_title(inputs)
	if (locale === "sl") return sl_plans_page_title(inputs)
	if (locale === "fi") return fi_plans_page_title(inputs)
	if (locale === "sv") return sv_plans_page_title(inputs)
	if (locale === "vi") return vi_plans_page_title(inputs)
	if (locale === "tr") return tr_plans_page_title(inputs)
	if (locale === "el") return el_plans_page_title(inputs)
	if (locale === "bg") return bg_plans_page_title(inputs)
	if (locale === "ru") return ru_plans_page_title(inputs)
	if (locale === "sr") return sr_plans_page_title(inputs)
	if (locale === "uk") return uk_plans_page_title(inputs)
	if (locale === "ka") return ka_plans_page_title(inputs)
	if (locale === "hi") return hi_plans_page_title(inputs)
	if (locale === "th") return th_plans_page_title(inputs)
	if (locale === "ko") return ko_plans_page_title(inputs)
	if (locale === "zh") return zh_plans_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_plans_page_title(inputs)
	if (locale === "ja") return ja_plans_page_title(inputs)
	return en_plans_page_title(inputs)
});